import {formDataRequest, postRequest} from "../libs/AxiosService.util";
import Constants from "../config/constants";

export async function serviceSendMessage(params) {
    return await formDataRequest('chat/send/message', params, {}, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceGetChatInfo(params) {
    console.log('Constants.DEFAULT_CHAT_API_URL', Constants.DEFAULT_CHAT_API_URL);
    return await postRequest('chat/conversations', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceCreateGroup(params) {
    return await postRequest('chat/groups/create', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceUpdateGroup(params) {
    return await postRequest('chat/groups/update', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceGroupDelete(params) {
    return await postRequest('chat/groups/delete', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceExitGroup(params) {
    return await postRequest('chat/groups/exit', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceGetGroupDetail(params) {
    return await postRequest('chat/groups/detail', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceGetConversationDetail(params) {
    return await postRequest('chat/conversations/detail', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceGetConversationMessage(params) {
    return await postRequest('chat/conversations/messages', params, Constants.DEFAULT_CHAT_API_URL);
}
export async function serviceGetEmployeeList(params) {
    return await postRequest('chat/employees', params,Constants.CHAT_API_URL);
}
export async function serviceGetChatConvAdmin(params) {
    return await postRequest('chat/conversations/admin', params, Constants.CHAT_API_URL);
}
export async function serviceGetChatCoAdmin(params) {
    return await postRequest('chat/groups/add/co_admins', params, Constants.CHAT_API_URL);
}

